import React from 'react';
import { testimonials } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function Testimonial() {
  const {
    text
  } = useBrand();
  return <section className="bg-cream" data-id="element-108" data-mp="2658vwvoc87j1">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-109" data-mp="266a3gq65abw0">
        <h2 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-110" data-mp="2b4254bwldcde">
          From members
        </h2>
        <ul className="mt-8 grid gap-6 md:grid-cols-2" data-id="element-111" data-mp="2ytmsr83owxt0">
          {testimonials.map(testimonial => <li key={testimonial.name} className="rounded-brand border border-ink/10 bg-cream-light p-8" data-id="element-112" data-mp="33ry3rm5q1ect">
              <blockquote className="flex h-full flex-col" data-id="element-113" data-mp="2pvkj645w4wu4">
                <p className="font-serif text-xl font-medium leading-snug text-ink md:text-2xl" data-id="element-114" data-mp="2tti8r83kpky1">
                  “{text(testimonial.quote)}”
                </p>
                <footer className="mt-auto pt-6 text-sm text-ink-muted" data-id="element-115" data-mp="1ifees1wzjwsz">
                  <span className="text-ink" data-id="element-116" data-mp="1idbix195j9gc">{testimonial.name}</span> · {testimonial.detail}
                </footer>
              </blockquote>
            </li>)}
        </ul>
      </div>
    </section>;
}